import React, { Component } from 'react';
import mayanna from '../images/mayanna.png';
import wanessa from '../images/wanessa.png';
import temistocles from '../images/temistocles.png';
import hugo from '../images/hugo.png';

class Home extends Component {

    state = {
        medico : ''
    }

    render() {
        return (
            <div>
                <center>
                    <h1 style={{marginTop:'6%', color:'#ffffff'}}>Qual o seu <strong>médico</strong>?</h1>
                </center>
                    <div className="row" style={{marginTop:'8%'}}>
                        
                        <div className="col-md-3 ">
                            <div>
                            <button type="submit" className="btn btn-link btn-medico" onClick={()=>{
                                        this.props.history.push({pathname:`/2`, state:{medico:'Dra. Wanessa'}})
                                    }}>

                                    <img src={wanessa}  alt={"Dra. Wanessa"} className="rounded-circle shadow p-1 mb-5 imagem-medico"/>
                                    <center><h3 style={{color:"#ffffff"}}>Dra. Wanessa</h3></center>
                                </button>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div>
                                <button type="submit"  className="btn btn-link btn-medico" onClick={() => {
                                        this.setState({medico: 'Dr. Mayanna'}, ()=>{
                                            this.props.history.push({pathname:`/2`, state:{medico:'Dra. Mayanna'}})
                                        });}}>
                                        
                                    <img src={mayanna} alt={"Dra. Mayanna"} className="rounded-circle shadow p-1 mb-5 imagem-medico"/>
                                    <center><h3 style={{color:"#ffffff"}}>Dra. Mayanna</h3></center>
                                </button>
                            </div>
                        </div>
                        <div className="col-md-3 ">
                            <div >
                            <button type="submit" className="btn btn-link btn-medico" onClick={()=>{
                                        this.props.history.push({pathname:`/2`, state:{medico:'Dr. Hugo'}})
                                    }}>

                                    <img src={hugo} alt={"Dr. Hugo"} className="rounded-circle shadow p-1 mb-5 imagem-medico"/>
                                    <center><h3 style={{color:"#ffffff"}}>Dr. Hugo</h3></center>
                                </button>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div>
                                <button type="submit" className="btn btn-link btn-medico" onClick={() => {
                                        this.setState({medico: 'Dr. Temistocles'}, ()=>{
                                            this.props.history.push({pathname:`/2`, state:{medico:'Dr. Temistocles'}})
                                        });}}>
                                        
                                    <img src={temistocles}  alt={"Dr. Temistocles"} className="rounded-circle shadow p-1 mb-5 imagem-medico"/>
                                    <center><h3 style={{color:"#ffffff"}}>Dr. Temistocles</h3></center>
                                </button>
                            </div>
                        </div>

                </div>
            </div>

        );
    }
}

export default Home;